import { Component } from '@angular/core';

@Component({
  selector: 'app-why-egypt',
  templateUrl: './why-egypt.component.html',
  styleUrl: './why-egypt.component.scss'
})
export class WhyEgyptComponent {

  images: string[] = [
    'assets/whyegypt1.jpg',
    'assets/whyegypt2.jpg',
    'assets/whyegypt3.jpg'
  ];
}


